import { render, staticRenderFns } from "./I.vue?vue&type=template&id=1ece2c0c&scoped=true&"
import script from "./I.vue?vue&type=script&lang=ts&"
export * from "./I.vue?vue&type=script&lang=ts&"
import style0 from "./I.vue?vue&type=style&index=0&id=1ece2c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece2c0c",
  null
  
)

export default component.exports